"use client";

import { NumericFormat } from "react-number-format";
import styles from "./results.module.scss";

const ResultsSection = ({
  nbHits,
  hitsPerPage,
  query,
  page,
}: {
  nbHits: number;
  hitsPerPage: number;
  query: string;
  page: number;
}) => {
  return (
    <div className={`d-flex flex-column justify-content-between ${styles.resultsContainer}`}>
      <div className={`d-flex justify-content-center justify-content-lg-between ${styles.resultsText}`}>
        <span className={styles.resultsSectionDesktop}>
          <NumericFormat
            displayType="text"
            value={nbHits === 0 ? 0 : page * hitsPerPage + 1}
            thousandSeparator={true}
          />
          {` - `}
          <NumericFormat
            displayType="text"
            value={Math.min((page + 1) * hitsPerPage, nbHits)}
            thousandSeparator={true}
          />
          <span>{` of `}</span>
          <span className={styles.boldText}>
            <NumericFormat displayType="text" value={nbHits} thousandSeparator={true} />
          </span>
          <span>{` results`}</span>
          {query && (
            <span>
              {` for `} <span className={styles.query}>{`\u201c${query}\u201d`}</span>
            </span>
          )}
        </span>
        <span className={`${styles.resultsSectionMobile} justify-content-between`}>
          <span className={styles.boldText}>
            <NumericFormat displayType="text" value={nbHits} thousandSeparator={true} />
            {` results`}
          </span>
        </span>
      </div>
    </div>
  );
};

export default ResultsSection;
